/* 🤖 this file was generated by script */
export const wiconRefreshCw05 = {
  name: 'refresh_cw_05',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.45 12.9a8.49 8.49 0 01-15.81 3.35l-.25-.43m-.84-4.71a8.49 8.49 0 0115.81-3.36l.25.43M3.5 18.07l.74-2.74 2.73.74m10.08-8.14l2.73.74.74-2.74"/></svg>`,
};
